import React from "react";
import { NavigateFunction, RouteObject, Navigate, createSearchParams } from "react-router-dom";
import { Users, Firmware, Log, TerminalDataTable, FeedDayDataTable, FeedTimeDataTable, DeviceDataTable, FeedCurveDataTable, SystemDataTable, LANControllerConfig, FirmwareIO, DeviceChangeQueue, DataTableActions, Companies, CreateCompany, SystemLimits } from "../../Containers";
import TabMenu from "../Menus/tabMenu";
import { ToolsMenu_Pages } from "../pages";
import GraphQL from "../../Containers/FullViewScreens/ToolsScreens/graphQL";

export const Router = [{
  element: null,
  children: [
    { 
      path: `${ToolsMenu_Pages.log}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.log} key={ToolsMenu_Pages.log} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[]} />,
      children:[
        { index: true, Component:Log },
      ]
    },
    { 
      path: `${ToolsMenu_Pages.config}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.config} key={ToolsMenu_Pages.config} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[]} />,
      children:[
        { index:true, Component: LANControllerConfig},
      ]
    },
    { 
      path: `${ToolsMenu_Pages.firmware}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.firmware} key={ToolsMenu_Pages.firmware} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[ToolsMenu_Pages.firmwareIO]} />,
      children:[
        { index: true, Component: Firmware },
        { path: `${ToolsMenu_Pages.firmwareIO}`, Component: FirmwareIO }
      ]
    },
    { 
      path: `${ToolsMenu_Pages.deviceDataTables}`,
      element: <TabMenu toolsMenu main={ToolsMenu_Pages.queue} key={ToolsMenu_Pages.deviceDataTables} overrides={{base_alternative:ToolsMenu_Pages.home}} contexts={[ToolsMenu_Pages.terminal, ToolsMenu_Pages.feedDay, ToolsMenu_Pages.feedTime, ToolsMenu_Pages.device, ToolsMenu_Pages.feedCurve, ToolsMenu_Pages.system, ToolsMenu_Pages.actions]} />,
      children: [
        { index: true, Component: DeviceChangeQueue },
        { path: `${ToolsMenu_Pages.terminal}`, Component: TerminalDataTable },
        { path: `${ToolsMenu_Pages.feedDay}`, Component: FeedDayDataTable },
        { path: `${ToolsMenu_Pages.feedTime}`, Component: FeedTimeDataTable },
        { path: `${ToolsMenu_Pages.device}`, Component: DeviceDataTable },
        { path: `${ToolsMenu_Pages.feedCurve}`, Component: FeedCurveDataTable },
        { path: `${ToolsMenu_Pages.system}`, Component: SystemDataTable },
        { path: `${ToolsMenu_Pages.actions}`, Component: DataTableActions },
      ]
    },
    { path:`/${ToolsMenu_Pages.companies}`, element:<TabMenu toolsMenu key={ToolsMenu_Pages.companies} main={ToolsMenu_Pages.companies} overrides={{ base_alternative: ToolsMenu_Pages.home }} contexts={[ ToolsMenu_Pages.createCompany, ToolsMenu_Pages.systemLimits ]}/>, 
      children:[
        {index: true, Component: Companies},
        { path: `${ToolsMenu_Pages.createCompany}`, Component: CreateCompany },
        { path: `${ToolsMenu_Pages.systemLimits}`, Component: SystemLimits },
        {path: '*', element: <Navigate to={`/${ToolsMenu_Pages.companies}`} />}
      ]
    },
    { path:`/${ToolsMenu_Pages.users}`, element:<TabMenu toolsMenu key={ToolsMenu_Pages.users} main={ToolsMenu_Pages.users} overrides={{ base_alternative: ToolsMenu_Pages.home }} contexts={[]}/>, 
      children:[
        {index: true, Component:Users},
        {path: '*', element: <Navigate to={`/${ToolsMenu_Pages.users}`} />}
      ]
    },
    { path:`/${ToolsMenu_Pages.graphQL}`, element:<TabMenu toolsMenu key={ToolsMenu_Pages.graphQL} main={ToolsMenu_Pages.graphQL} overrides={{ base_alternative: ToolsMenu_Pages.home }} contexts={[]}/>, 
    children:[
      {index: true, Component:GraphQL},
      {path: '*', element: <Navigate to={`/${ToolsMenu_Pages.graphQL}`} />}
    ]
  }
  ]
}] as RouteObject[]

export const NavigationFunction = (Navigator: NavigateFunction, navigation_page: ToolsMenu_Pages, navigation_tab: ToolsMenu_Pages, currentDomain?: string) => { //TODO: populate nested navigations?
  const search = currentDomain ? createSearchParams({domain: currentDomain }).toString() : undefined;
  switch (navigation_page) {
    case ToolsMenu_Pages.home: {
      Navigator({pathname: ToolsMenu_Pages.home, search})
      break
    }

    case ToolsMenu_Pages.log: {
      switch (navigation_tab) {
        default: {
          Navigator({pathname: `/${ToolsMenu_Pages.log}`, search}, {state:{global_index: 0, tab:0}})
          break
        }
      }
      break
    }

    case ToolsMenu_Pages.config: {
      switch (navigation_tab) {
        default: {
          Navigator({pathname: `/${ToolsMenu_Pages.config}`, search}, { state: { global_index: 1, tab: 0 } })
          break
        }
      }
      break
    }
    case ToolsMenu_Pages.firmware: {
    
      switch (navigation_tab) {
        default: {
          Navigator({pathname: `/${ToolsMenu_Pages.firmware}`, search}, { state: { global_index: 2, tab: 0 } })
          break
        }
      }
      break
    }
    case ToolsMenu_Pages.companies:
      Navigator({pathname: `/${ToolsMenu_Pages.companies}`, search}, {state: {global_index:3, tab:0}})
      break
    
      case ToolsMenu_Pages.users:
      Navigator({pathname: `/${ToolsMenu_Pages.users}`, search}, {state: {global_index:4, tab:0}})
    break
    
    case ToolsMenu_Pages.graphQL:
      Navigator({pathname: `/${ToolsMenu_Pages.graphQL}`, search}, {state: {global_index:5, tab:0}})
      break
    
      default: console.log("Error page not found (404)???, [ToolsMenu]")
  }
}
